import type { Html } from 'mdast';
import type { CompileContext, Extension as FromMarkdownExtension, Handle, Token } from 'mdast-util-from-markdown';

const contextMap = new WeakMap<Token, { chunks: string[]; lastEndLine: number }>();

function findJsxTableToken(this: CompileContext): Token | undefined {
  const events = this.tokenStack;
  for (let i = events.length - 1; i >= 0; i -= 1) {
    if (events[i][0].type === 'jsxTable') return events[i][0];
  }
  return undefined;
}

function enterJsxTable(this: CompileContext, token: Parameters<Handle>[0]): void {
  contextMap.set(token, { chunks: [], lastEndLine: token.start.line });
  this.enter({ type: 'html', value: '' } as Html, token);
}

function exitJsxTableData(this: CompileContext, token: Parameters<Handle>[0]): void {
  const tableToken = findJsxTableToken.call(this);
  if (!tableToken) return;
  const ctx = contextMap.get(tableToken);
  if (ctx) {
    const gap = token.start.line - ctx.lastEndLine;
    if (ctx.chunks.length > 0 && gap > 0) {
      ctx.chunks.push('\n'.repeat(gap));
    }
    ctx.chunks.push(this.sliceSerialize(token));
    ctx.lastEndLine = token.end.line;
  }
}

function exitJsxTable(this: CompileContext, token: Parameters<Handle>[0]): void {
  const ctx = contextMap.get(token);
  const node = this.stack[this.stack.length - 1] as Html;
  if (ctx) {
    node.value = ctx.chunks.join('');
    contextMap.delete(token);
  }
  this.exit(token);
}

export function jsxTableFromMarkdown(): FromMarkdownExtension {
  return {
    enter: {
      jsxTable: enterJsxTable,
    },
    exit: {
      jsxTableData: exitJsxTableData,
      jsxTable: exitJsxTable,
    },
  };
}
